import { Channels } from '@/core/constants/channelConstants';
import { Roles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

export class OrderPolicy extends BasePolicy {
  static canList() {
    const roles = [
      Roles.SELLER,
      Roles.CUSTOMER_RETAIL,
      Roles.CUSTOMER_WHOLESALER,
      Roles.EXPRESS_SALES,
      Roles.BRIEFCASE,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.DIRECTOR_NON_COMMERCIAL,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
      Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
      Roles.SUPER_USER,
      Roles.MARKETING,
      Roles.POST_SALE,
    ];

    const channels = [Channels.WHOLESALER, Channels.RETAIL];

    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }

  static canCreate() {
    const roles = [
      Roles.SELLER,
      Roles.CUSTOMER_RETAIL,
      Roles.CUSTOMER_WHOLESALER,
      Roles.EXPRESS_SALES,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.SUPER_USER,
      Roles.MARKETING,
      Roles.POST_SALE,
    ];

    return this.hasAnyRole(roles);
  }

  static canDeleteAny() {
    const roles = [
      Roles.SELLER,
      Roles.CUSTOMER_RETAIL,
      Roles.CUSTOMER_WHOLESALER,
      Roles.EXPRESS_SALES,
      Roles.MANAGER,
      Roles.SUB_MANAGER,
      Roles.REGIONAL_MANAGER,
      Roles.SUB_DIRECTOR,
      Roles.DIRECTOR,
      Roles.SUPER_USER,
    ];

    return this.hasAnyRole(roles);
  }
}
